function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTyp2Symbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.916665 52.916666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    width: 49.853458,
    height: 49.853458,
    x: 1.4834656,
    y: 1.4834656,
    ry: 0.74143237
  }), /*#__PURE__*/React.createElement("text", {
    x: 26.5,
    y: 30,
    textAnchor: "middle",
    style: {
      fontSize: 16,
      fontFamily: "'Segoe UI',sans-serif",
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 1.2,
      strokeOpacity: 1
    }
  }, "AG"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyp2Symbol);
export default __webpack_public_path__ + "static/media/Typ2Symbol.d605e74a18c0ec51c9f5af0d93ea60e6.svg";
export { ForwardRef as ReactComponent };